import { useQuery } from "@tanstack/react-query";
import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";

async function fetchRelatedTasksForProduct(shortId: string) {
  const url = `${TASKS_SERVICE_URL}/v1/tasks/for_product?short_id=${shortId}`;
  const { result } = await fetchAPI("GET", url);
  return result.data;
}

export function useRelatedTasksForProduct(shortId: string) {
  return useQuery({
    enabled: !!shortId,
    queryKey: ["tasks", "product", shortId],
    queryFn: async () => await fetchRelatedTasksForProduct(shortId),
    staleTime: 0,
  });
}
